module.exports = __webpack_public_path__ + "img/54.0c14b5e0.png";